import { useEffect } from "react";
import { API } from "@/lib/api";

const surface = () => {
  const p = window.location.pathname;
  return p.startsWith("/embed") ? "embed" : p.startsWith("/chat") ? "page" : "widget";
};

const where = () => {
  if (window.parent === window) return { host: window.location.hostname, path: window.location.pathname };
  const origin = window.location.ancestorOrigins?.[0] || document.referrer;
  try {
    const u = new URL(origin);
    return { host: u.hostname, path: u.pathname };
  } catch {
    return { host: "", path: "" };
  }
};

export const track = (type, sessionId, extra = {}) => {
  const body = JSON.stringify({ type, session_id: sessionId, surface: surface(), ...where(), ...extra });
  const url = `${API}/events`;
  if (navigator.sendBeacon?.(url, new Blob([body], { type: "application/json" }))) return;
  fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true, credentials: "include" }).catch(() => {});
};

const DOC_TEXT = /etf facts|fund facts|aperçu|prospectus|fact ?sheet|product sheet|annual report|interim|financial statements/i;
const isDoc = (a) => !a.href.includes("/api/brief/") && (/\.pdf($|[?#])/i.test(a.href) || DOC_TEXT.test(a.textContent || ""));

const CITE = /^\[\d+\]$/;
const docLabel = (a) => {
  const text = (a.textContent || "").trim();
  if (!CITE.test(text)) return text;
  const chip = [...(a.closest("[data-testid=chat-panel]")?.querySelectorAll("a[data-testid^=source-chip-]") || [])].find((c) => c.href === a.href);
  return (chip?.textContent || "").trim() || a.href.split("/").pop();
};

// Clicks on Harvest documents inside the Ceres window (left or middle click).
export const trackDocClick = (sessionId) => (e) => {
  const a = e.target.closest?.("a[href]");
  if (a && isDoc(a)) track("doc_open", sessionId, { url: a.href.slice(0, 1000), label: docLabel(a).slice(0, 200) });
};

// One session = the Ceres window being open; pings every minute while visible so length is measured even if the tab is just closed.
export const useSessionTracking = (sessionId) => {
  useEffect(() => {
    track("open", sessionId);
    const ping = setInterval(() => document.visibilityState === "visible" && track("ping", sessionId), 60000);
    const bye = () => track("close", sessionId);
    window.addEventListener("pagehide", bye);
    return () => {
      clearInterval(ping);
      window.removeEventListener("pagehide", bye);
      bye();
    };
  }, [sessionId]);
};
